module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1516-505c2adb43dcf2b021e25302b39af0e2.png";